import useLanguage from "../../hooks/useLanguage";
import useMediaQuery from "../../hooks/useMediaQuery";
import CommonPage from "../../components/common-page";
import VirtualizedTable from "../../components/virtualTable";
import { tableLayout } from "./tableLayout";
import { Skeleton } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import styled from "styled-components";

const StyledSkeleton = styled(Skeleton)`
  background-color: ${({ theme }) =>
    theme.palette.background.default}21 !important;
`;

const QueueSkeleton = () => {
  const [
    {
      pages: { queue: text },
    },
  ] = useLanguage();
  const isMobile = useMediaQuery();

  const titleText = isMobile ? text.inPageTitle.short : text.inPageTitle.long;
  const tableColumns = tableLayout?.en?.map((column) => column.dataKey);

  const skeletonData = Array(16)
    .fill(null)
    .map(() =>
      tableColumns.reduce((acc, column) => {
        acc[column] = <Skeleton />;
        acc.disabled = true;
        return acc;
      }, {})
    );

  return (
    <CommonPage
      title={titleText}
      subtitle={text.subtitle}
      action={{
        label: <StyledSkeleton variant="text" width={isMobile ? 45 : 85} />,
        icon: <RefreshRoundedIcon fontSize="small" />,
        disabled: true,
        onClick: () => {},
      }}
    >
      <VirtualizedTable columns={tableLayout} data={skeletonData} />
    </CommonPage>
  );
};

export default QueueSkeleton;
